export const cities_data = [
  {
    key: "1",
    id: "CI357268",
    cityName: "Los Angeles",
    stateName: "California",
    countryName: "United States",
    status: "Active",
  },
  {
    key: "2",
    id: "CI357267",
    cityName: "New York City",
    stateName: "New York",
    countryName: "United States",
    status: "Active",
  },
  {
    key: "3",
    id: "CI357266",
    cityName: "Houston",
    stateName: "Texas",
    countryName: "United States",
    status: "Active",
  },
  {
    key: "4",
    id: "CI357265",
    cityName: "Munich",
    stateName: "Bavaria",
    countryName: "Germany",
    status: "Active",
  },
  {
    key: "5",
    id: "CI357264",
    cityName: "Montreal",
    stateName: "Quebec",
    countryName: "Canada",
    status: "Active",
  },
  {
    key: "6",
    id: "CI357263",
    cityName: "Toronto",
    stateName: "Ontario",
    countryName: "Canada",
    status: "Active",
  },
  {
    key: "7",
    id: "CI357262",
    cityName: "Miami",
    stateName: "Florida",
    countryName: "United States",
    status: "Active",
  },
  {
    key: "8",
    id: "CI357261",
    cityName: "Calgary",
    stateName: "Berlin",
    countryName: "Germany",
    status: "Active",
  },
  {
    key: "9",
    id: "CI357260",
    cityName: "Melbourne",
    stateName: "Victoria",
    countryName: "Australia",
    status: "Active",
  },
  {
    key: "10",
    id: "CI357259",
    cityName: "Johannesburg",
    stateName: "Gauteng",
    countryName: "Egypt",
    status: "Active",
  },
];
